import { defineComponent, ref, provide, reactive, toRefs, getCurrentInstance, onMounted, nextTick } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import PageLoading from '@/components/common/PageLoading.vue';
import Swiper from '@/components/layout/Swiper.vue';
import SearchBar2 from '@/components/layout/SearchBar2.vue';
import Header2 from '@/components/layout/header2.vue';
import Footer from '@/components/layout/footer.vue';
import Menu from '@/components/layout/menu.vue';
import bus from 'vue3-eventbus';
import SideComponent from '@/components/common/SideComponent.vue';
import Loading from '@/components/common/Loading.vue';
import { wexinShare } from '@/utils/wxshare.js';
import { trackContentView, CONTENT_VIEW_TYPES } from '@/utils/contentView.js';

export default defineComponent({
	components: {
		PageLoading,
		Header2,
		Menu,
		Swiper,
		SearchBar2,
		Footer,
		SideComponent,
		Loading,
	},
	setup() {
		const { proxy } = getCurrentInstance();
		const route = useRoute();
		const data = reactive({
			isMobile: false,
			isLoading: true,
			showHeader: true,
			loginStyle: 'min-width:141px;',
			mobileIconStyle: 'color:rgba(223, 58, 8, 1);',
			showListIcon: true,
			videoDetail: {},
		});

		const showMenu = ref(proxy.$menus);
		provide('showMenu', showMenu);

		const outerStyleStr = ref('position:relative;left:10%;top:40%;transform:translate(-10%,-40%);width:auto;');
		provide('outerStyleStr', outerStyleStr);

		const styleStr = ref('height:45px;');
		provide('styleStr', styleStr);

		const showSearchText = ref(false);
		provide('showSearchText', showSearchText);

		const store = useStore();
		const id = route.query.id;

		const getVideo = (videoId = 0) => {
			store.dispatch('common/InternationalDetail', {
				id: videoId,
			}).then((res) => {
				data.videoDetail = res;
				if (data.videoDetail.size) {
					data.videoDetail.size = proxy.$utils.round(data.videoDetail.size / 1024 / 1024, 2);
				}
				if (data.videoDetail.keywords == null) {
					data.videoDetail.keywords = [];
				}
				trackContentView(store, CONTENT_VIEW_TYPES.international, videoId, res.views ?? 0);
				proxy.$utils.getImageSize(res.thumb).then((imginfo) => {
					if (parseInt(imginfo.width) < parseInt(imginfo.height)) {
						data.videoDetail.direction = 3;
					} else if (parseInt(imginfo.width) > parseInt(imginfo.height)) {
						data.videoDetail.direction = 2;
					} else {
						data.videoDetail.direction = 1;
					}
				});
				wxshare(res);
				bus.emit('showFooter', true);
			});
		};

		const wxshare = (share_data) => {
			const protocol = window.location.protocol;
			const hostname = window.location.hostname;
			let url = `${protocol}//${hostname}`;
			if (hostname.indexOf('www') === -1) {
				url = `${protocol}//www.${hostname}`;
			}
			url += route.fullPath;
			store.dispatch('common/Jssdk', { url }).then((res) => {
				wexinShare(res, {
					title: share_data.title.replace('<br>', ' '),
					desc: '',
					link: url,
					imgUrl: store.state.common.siteInfo.logo,
				});
			});
		};

		const viewBox = ref(null);
		const scroll = (val) => {
			if (!viewBox.value) return;
			viewBox.value.scrollIntoView({
				behavior: 'smooth',
				block: val === 'top' ? 'start' : 'end',
				inline: 'center',
			});
		};

		onMounted(async () => {
			getVideo(id);
			await nextTick();
			setTimeout(() => {
				data.isLoading = false;
				if (viewBox.value) {
					viewBox.value.scrollIntoView({
						behavior: 'smooth',
						block: 'start',
						inline: 'center',
					});
				}
			}, 600);
		});

		return {
			...toRefs(data),
			viewBox,
			scroll,
			getVideo,
			wxshare,
		};
	},
	mounted() {
		this.$nextTick(() => {
			this.isMobile = document.documentElement.clientWidth < 768;
		});
	},
});
